
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#050a14] border-t border-[#1e3a8a]/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <img src="https://static.readdy.ai/image/7302b421718742a693240adfeb05edc7/5b9e3cd7f2338041e3bb6bb21e39ce32.jpeg" alt="Nexora Corp" className="h-20 w-auto" />
            </div>
            <p className="text-2xl font-serif text-white/70 mb-6 leading-tight">Get your demo website today</p>
            <div className="flex items-center gap-2">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="flex-1 bg-[#0a1628] border border-[#1e3a8a]/30 rounded-lg px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-[#1e3a8a] transition-colors text-sm"
              />
              <button className="w-12 h-12 bg-[#0a1628] hover:bg-[#0d1e38] border border-[#1e3a8a]/50 rounded-lg flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-send-plane-fill"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-6">Services</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-white/70 hover:text-white transition-colors cursor-pointer">Website Builds</a></li>
              <li><a href="#services" className="text-white/70 hover:text-white transition-colors cursor-pointer">AI Automation</a></li>
              <li><a href="#services" className="text-white/70 hover:text-white transition-colors cursor-pointer">Lead Funnels</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-6">Company</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-white/70 hover:text-white transition-colors cursor-pointer">About</a></li>
              <li><a href="#process" className="text-white/70 hover:text-white transition-colors cursor-pointer">Process</a></li>
              <li><a href="#contact" className="text-white/70 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><Link to="/join-our-team" className="text-white/70 hover:text-white transition-colors cursor-pointer">Join Our Team</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-6">Contact</h4>
            <ul className="space-y-3">
              <li className="text-white/70">
                <a href="tel:626-806-4641" className="hover:text-white transition-colors cursor-pointer">626-806-4641</a>
              </li>
              <li className="text-white/70">
                <a href="mailto:nexorasolutionsbiz@gmail.com" className="hover:text-white transition-colors cursor-pointer break-all">nexorasolutionsbiz@gmail.com</a>
              </li>
              <li className="text-white/70">United States<br />(Remote Services)</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1e3a8a]/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-sm text-white/60">&copy; 2025 Nexora Corp. All rights reserved.</p>
            
            <div className="flex items-center gap-4">
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-[#1e3a8a]/30 rounded-full flex items-center justify-center text-white/70 hover:border-[#1e3a8a] hover:text-white transition-all cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-[#1e3a8a]/30 rounded-full flex items-center justify-center text-white/70 hover:border-[#1e3a8a] hover:text-white transition-all cursor-pointer">
                <i className="ri-twitter-x-fill"></i>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-[#1e3a8a]/30 rounded-full flex items-center justify-center text-white/70 hover:border-[#1e3a8a] hover:text-white transition-all cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-[#1e3a8a]/30 rounded-full flex items-center justify-center text-white/70 hover:border-[#1e3a8a] hover:text-white transition-all cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
            </div>

            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
